import React, { useState, useEffect } from "react";

import gql from "graphql-tag";

import moment from "moment";

import { useHistory, useParams } from "react-router-dom";

import { useApolloClient } from "react-apollo";

import { Field, Control, Label, Icon, Button, Radio } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  DateInput,
  BookingCodeSelect,
  SystemCodeSelect
} from "../../../components/inputs";

import { ReactTable } from "../../../components/DataTable/DataTable";

import { DRIVER_BOOKING_LIST_COLUMNS } from "./columns";

const ALL_BOOKINGS_QUERY = gql`
  query Bookings($where: BookingWhereInput) {
    Bookings(where: $where, orderByMulti: [PickupDate_DESC], first: 100) {
      RecId
      Employee {
        RecId
        EmployeeId
        FullName
      }
      BookingCode {
        RecId
        BookingCode
        Description
      }
      PickupDate
      BookedTrip
      Comment
    }
  }
`;

const SINGLE_EMPLOYEE_QUERY = gql`
  query Employee($where: EmployeeWhereUniqueInput!) {
    Employee(where: $where) {
      RecId
      FullName
      EmployeeId
    }
  }
`;

const useEmployee = id => {
  const client = useApolloClient();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const {
          data: { Employee = {} }
        } = await client.query({
          query: SINGLE_EMPLOYEE_QUERY,
          variables: {
            where: {
              RecId: parseInt(id)
            }
          }
        });
        setData(Employee);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchData();
    }
  }, [client, id]);
  return {
    data,
    loading
  };
};

const DriverBookingsList = () => {
  const client = useApolloClient();
  const history = useHistory();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    startDate: moment()
      .add(-60, "days")
      .format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD")
  });
  useEmployee(id);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const where = {
          BookingDate_gt: state.startDate,
          BookingDate_lt: state.endDate,
          EmployeeRecIdRef: parseInt(id)
        };

        if (state.BookingCodeRecIdRef) {
          where.BookingCodeRecIdRef = parseInt(state.BookingCodeRecIdRef);
        }

        const {
          data: { Bookings = [] }
        } = await client.query({
          query: ALL_BOOKINGS_QUERY,
          variables: {
            where
          }
        });
        setData(Bookings);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [client, id, state.BookingCodeRecIdRef, state.endDate, state.startDate]);

  const handleChange = e => {
    setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div>
      <div className="driver-bookings-header">
        <Field>
          <Control>
            <Button color="primary" onClick={() => history.go(-1)}>
              <Icon>
                <FontAwesomeIcon icon="arrow-left" />
              </Icon>
              <span>Back</span>
            </Button>
          </Control>
        </Field>

        <Field kind="group">
          <Control>
            <SystemCodeSelect
              icon="book-open"
              label="Category"
              lookup={{ Category: "BookingCodes", CodeName: "BookCatg" }}
              name="CodeCatgRecIdRef"
              value={state.CodeCatgRecIdRef}
              onChange={({ target: { name, value } }) =>
                handleChange({ target: { name, value } })
              }
            />
          </Control>
          <Control>
            <Label>Booking Code</Label>
            <BookingCodeSelect
              defaults={{ label: "All", value: "" }}
              icon="book-open"
              name="BookingCodeRecIdRef"
              value={state.BookingCodeRecIdRef}
              onChange={({ target: { name, value } }) =>
                handleChange({ target: { name, value } })
              }
            />
          </Control>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              name="startDate"
              value={state.startDate}
              onChange={handleChange}
            />
          </Control>
          <Control>
            <Label>End Date</Label>
            <DateInput
              name="endDate"
              value={state.endDate}
              onChange={handleChange}
            />
          </Control>
        </Field>
        <Field>
          <Control>
            <Label>
              <Radio name="historyType" />
              &nbsp;Order History
            </Label>
            <Label>
              <Radio defaultChecked name="historyType" />
              &nbsp;Booking History
            </Label>
          </Control>
        </Field>
      </div>

      <ReactTable
        columns={DRIVER_BOOKING_LIST_COLUMNS}
        data={data}
        loading={loading}
        sortBy={[{ id: "PickupDate", desc: true }]}
      />
    </div>
  );
};

DriverBookingsList.propTypes = {};
export default DriverBookingsList;
